var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume"},[_c('em',[_vm._v("我的简历页面-暂时保留")])])
}]

export { render, staticRenderFns }